import { actionGenerator, IReduxAction } from '../../redux/actionGenerator';
import { IDepositAccountState } from '../../types/reducers/depositAccount';

export const UPDATE_DEPOSIT_ACCOUNT_PAYMENT_TOKEN = 'DEPOSIT_ACCOUNT :: UPDATE_PAYMENT_TOKEN';

export type TUpdateDepositAccountPaymentTokenAction = IReduxAction<
  typeof UPDATE_DEPOSIT_ACCOUNT_PAYMENT_TOKEN,
  IDepositAccountState['paymentToken']
>;

export const updateDepositAccountPaymentToken = actionGenerator<
  typeof UPDATE_DEPOSIT_ACCOUNT_PAYMENT_TOKEN,
  IDepositAccountState['paymentToken']
>(UPDATE_DEPOSIT_ACCOUNT_PAYMENT_TOKEN);
